module.exports = __webpack_public_path__ + "img/creative-logo1.7921eb0a.png";